// extracted by mini-css-extract-plugin
module.exports = {"main":"QueryModule_main__3LQKK","query":"QueryModule_query__KjFX4","input_area":"QueryModule_input_area__2L0s-","response":"QueryModule_response__3J_v5"};